import { HttpError, Membership } from '@rd/types';
import { toObject } from '@rd/utils/array.utils';
import {
  MembershipActions,
  MembershipActionTypes,
} from '../actions/membership.actions';

export interface MembershipState {
  memberships: {
    data: {
      [key: string]: Partial<Membership>;
    };
    error: HttpError | null;
    isLoaded: boolean;
    loading: boolean;
  };
  createMembership: {
    error: HttpError | null;
    loading: boolean;
  };
  updateMembership: {
    error: HttpError | null;
    loading: boolean;
  };
}

const initialState: MembershipState = {
  memberships: {
    data: {},
    error: null,
    isLoaded: false,
    loading: false,
  },
  createMembership: {
    error: null,
    loading: false,
  },
  updateMembership: {
    error: null,
    loading: false,
  },
};

export function membershipReducer(
  state: MembershipState = initialState,
  action: MembershipActions,
): MembershipState {
  switch (action.type) {
    case MembershipActionTypes.LOAD_MEMBERSHIPS:
      return {
        ...state,
        memberships: {
          ...state.memberships,
          loading: true,
        },
      };

    case MembershipActionTypes.LOAD_MEMBERSHIPS_SUCCESS:
      return {
        ...state,
        memberships: {
          data: toObject(action.payload, 'id'),
          error: null,
          isLoaded: true,
          loading: false,
        },
      };

    case MembershipActionTypes.LOAD_MEMBERSHIPS_FAIL:
      return {
        ...state,
        memberships: {
          ...state.memberships,
          data: {},
          error: action.payload,
          loading: false,
        },
      };

    case MembershipActionTypes.CREATE_CASHBACK_MEMBERSHIP:
      return {
        ...state,
        createMembership: {
          error: null,
          loading: true,
        },
      };

    case MembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        createMembership: {
          error: null,
          loading: false,
        },
      };

    case MembershipActionTypes.CREATE_MEMBERSHIP_FAIL:
      return {
        ...state,
        createMembership: {
          error: action.payload,
          loading: false,
        },
      };

    case MembershipActionTypes.UPDATE_MEMBERSHIP:
      return {
        ...state,
        updateMembership: {
          error: null,
          loading: true,
        },
      };

    case MembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        updateMembership: {
          error: null,
          loading: false,
        },
      };

    case MembershipActionTypes.UPDATE_MEMBERSHIP_FAIL:
      return {
        ...state,
        updateMembership: {
          error: action.payload,
          loading: false,
        },
      };

    case MembershipActionTypes.CLEAR_CREATE_AND_UPDATE_MEMBERSHIP_ERRORS:
      return {
        ...state,
        createMembership: {
          ...state.createMembership,
          error: null,
        },
        updateMembership: {
          ...state.updateMembership,
          error: null,
        },
      };
  }
  return state;
}
